import { api } from "@/lib/api";

// Opens WhatsApp with a pre-filled, server-generated message.
export async function openWhatsApp({ items = null, name = "", address = "", pincode = "" } = {}) {
  try {
    const { data } = await api.post("/whatsapp-order", { items, name, address, pincode });
    if (data.url) {
      window.open(data.url, "_blank", "noopener");
      return true;
    }
  } catch (e) {
    // fallback: open plain chat if number known via settings is handled by caller
  }
  return false;
}

export function whatsappLink(number, text) {
  const num = (number || "").replace(/\D/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(text || "")}`;
}
